module.exports = __webpack_public_path__ + "static/relative-faux-webfont-7af5de87f8efdfdcdc61972890961b24.woff2";